import { Heart, Clock, MapPin, Users, Compass, Lock } from "lucide-react";

const ICONS = { interest: Heart, time: Clock, location: MapPin, relationship: Users, intent: Compass, consent: Lock };

export const AIChip = ({ chip, consent, stacked = false }) => {
  const Icon = ICONS[chip.id];
  const off = chip.gate && !consent;
  return (
    <div
      data-testid={`ai-chip-${chip.id}`}
      className={`glass ${chip.gate ? "glass-dark ai-gate" : "glass-light"} ${off ? "is-off" : ""} flex ${stacked ? "flex-col items-start gap-1.5 px-3 py-2.5" : "items-center gap-2.5 py-2 pl-2 pr-4"} rounded-2xl whitespace-nowrap`}
    >
      <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full" style={{ background: chip.gate ? "rgba(255,255,255,.12)" : `${chip.color}33`, color: chip.gate ? "#fff" : chip.color }}>
        <Icon size={14} strokeWidth={1.8} aria-hidden />
      </span>
      <span className="leading-tight">
        <span className={`block text-[13px] font-semibold ${chip.gate ? "text-white" : "text-[#08090D]"}`}>{chip.label}</span>
        <span className={`block text-[11px] ${chip.gate ? (off ? "text-[#D9A7E8]" : "text-white/70") : "text-[#5b5f73]"}`}>
          {chip.gate ? (off ? "Off · blocks match" : "Required · On") : chip.detail}
        </span>
      </span>
    </div>
  );
};
